/* libs/oyan-ui/src/lib/features/products/components/product-edit-form/product-edit-form.component.scss */
:host {
  display: block;
}
.oyan-ui-edit-product-dialog {
  min-width: 400px;
  max-width: 600px;
}
.oyan-ui-edit-product-dialog .dialog-card-header {
  padding: 0;
  margin: 0;
}
.oyan-ui-edit-product-dialog .dialog-card-header .dialog-toolbar {
  padding: 0 16px;
}
.oyan-ui-edit-product-dialog .dialog-card-header .dialog-toolbar .dialog-card-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
}
.oyan-ui-edit-product-dialog .dialog-card-header .dialog-toolbar .regular-round-button {
  margin-left: auto;
}
.oyan-ui-edit-product-dialog .dialog-card-content {
  min-height: 100px;
}
.oyan-ui-edit-product-dialog .dialog-card-actions {
  padding: 16px 24px;
  gap: 12px;
}
.edit-product-container {
  padding: 16px;
}
.edit-product-container .form-actions {
  margin-top: 16px;
}
/*# sourceMappingURL=product-edit-form.component.css.map */
